import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { StoreContexto } from '../Contexto/Provider';

import '../Estilos/Componentes.css';
import '../Estilos/Container.css';
import '../Estilos/Dropdown.css';
import BotaoCabecalho from './BotaoCabecalho';
import ModalConfirmacao from './ModalConfirmacao';

export default function CabecalhoDashboard(props) {
  const [open, setopen] = useState(false);
  const { auth, setAuth } = useContext(StoreContexto);

  const { nomeSalvo } = auth;

  const [modalConfirmacaoVisivel, setModalConfirmacaoVisivel] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="Cabecalho">
      <img
        className="header_logo"
        src={require('../Icones/LOGOJABILB.svg').default}
        width={100}
        height={50}
        alt="jabil logo"
        onClick={() => {
          navigate('/wellcome');
        }}
      />

      {modalConfirmacaoVisivel ? (
        <ModalConfirmacao
          aviso="Deseja realmente sair do sistema?"
          externo
          clicadoVolta={() => {
            setModalConfirmacaoVisivel(false);
            setopen(false);
          }}
          clicado={async () => {
            setModalConfirmacaoVisivel(false);
            localStorage.clear();
            setopen(false);
            setAuth({ token: '', idLogin: -1, controleSalvo: '', nomeSalvo: '' });
          }}
        />
      ) : null}
      <Link to="/">
        <div
          style={{
            fontSize: 20,
            marginTop: 20,
            marginRight: 40,
            color: 'white',
            textAlign: 'right',
            fontFamily: 'montserrat',
          }}
        >
          Sair
        </div>
      </Link>
    </div>
  );
}
